import tmhRequest from '@/config/tmhRequest'

export default {
  searchCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/searchcard',
      method: 'post',
      params: data,
    })
  },

  searchListCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/searchlistcard',
      method: 'post',
      params: data,
    })
  },

  searchNoPlusCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/searchnopluscard',
      method: 'post',
      params: data,
    })
  },


  searchCardCount: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/searchcardcount',
      method: 'post',
      params: data,
    })
  },

  searchCardByPage: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/searchcardbypage',
      method: 'post',
      params: data,
    })
  },

  addCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/addcard',
      method: 'post',
      data: data,
    })
  },

  editCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/card/editcard',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/card.js